// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZiSC","input":"styles_input__1J7EA"};